export enum SupportCategory {
    RequestFeature = 'request_feature',
    ReportIssue = 'report_issue',
    PaymentSubscription = 'payment_subscription',
    Other = 'other'
}